import { ComponentProps, useMemo } from 'react';
import { Box } from '@mui/material';
import { type DiscoveryGenreTileData } from 'services/store/discovery/types';
import getFormulaUrl from '../../helpers/getFormulaUrl';
import DiscoveryTile from '../DiscoveryTile/DiscoveryTile';
import { StyledGenreLink } from './styled';

interface Props extends ComponentProps<typeof Box> {
  data: DiscoveryGenreTileData;
}

const GenreTile = ({ data: { meta, image }, ...props }: Props) => {
  const link = useMemo(() => {
    if (!meta) {
      return '';
    }
    return getFormulaUrl(meta);
  }, [meta]);

  return (
    <DiscoveryTile {...props} image={image}>
      <StyledGenreLink to={link} />
    </DiscoveryTile>
  );
};

export default GenreTile;
